module.exports = __webpack_public_path__ + "img/ProductManager.60e32e9f.svg";